var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "_component-icon-svg",
      attrs: {
        width: "20",
        height: "16",
        viewBox: "0 0 20 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("path", {
        style: _vm.componentStyle,
        attrs: {
          d:
            "M0 3.76066C8.37209 12.5844 11.1628 13.7229 20 16V0.0603924C19.6899 -0.603758 16 4.44378 0 3.76066Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }